"use client";
import { jsx } from "react/jsx-runtime";
const InlineMessageHeading = (props) => {
  const { children, headingLevel, className } = props;
  switch (headingLevel) {
    case "1":
      return /* @__PURE__ */ jsx("h1", { className, children });
    case "2":
      return /* @__PURE__ */ jsx("h2", { className, children });
    case "3":
      return /* @__PURE__ */ jsx("h3", { className, children });
    case "4":
      return /* @__PURE__ */ jsx("h4", { className, children });
    case "5":
      return /* @__PURE__ */ jsx("h5", { className, children });
    default:
      return /* @__PURE__ */ jsx("h6", { className, children });
  }
};
var InlineMessageHeading_default = InlineMessageHeading;
export {
  InlineMessageHeading_default as default
};
